module.exports = __webpack_public_path__ + "media/images/application/placeholder/team-placeholder-82c8cff41f8f057a65f6f0dfd356107b.jpg";